<template>
    <v-row justify="center">
        <v-col v-for="(mark, index) in marks" :key="index" cols="6" md="4" lg="2">
            <v-card outlined min-height="120" class="mark-card rounded-xl">
                <div width="100%">
                    <img :src="mark.logo" :alt="mark.name" class="d-block" />
                </div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    data() {
        return {
            marks: [
                {
                    name: "강원대학교",
                    logo: "/images/marks/mark-1.png",
                },
                {
                    name: "한림대학교",
                    logo: "/images/marks/mark-2.png",
                },
                {
                    name: "가톨릭 관동대학교",
                    logo: "/images/marks/mark-3.png",
                },
                {
                    name: "(재)춘천바이오\n산업진흥원",
                    logo: "/images/marks/mark-4.png",
                },
                {
                    name: "강릉과학산업진흥원",
                    logo: "/images/marks/mark-5.png",
                },
                {
                    name: "(재)홍천메디컬\n허브연구소 ",
                    logo: "/images/marks/mark-6.png",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.mark-card {
    border-color: var(--v-grey-lighten3) !important;
    padding: 16px 12px;
    text-align: center;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>